export const isAndroidApp = () => navigator.userAgent.includes('MaldhowrCustomer/');
export const customerAppLogin = () => isAndroidApp() || new URLSearchParams(window.location.search).get('customerApp') === '1';
export const nativeFilesAvailable = () => isAndroidApp() && typeof window.MaldhowrNative?.postMessage === 'function';

let pending = false;
export async function nativeFile(kind, blob, filename) {
  if (!nativeFilesAvailable()) return false;
  if (pending) throw new Error('Finish the current sharing or download action first.');
  if (blob.size > 10 * 1024 * 1024) throw new Error('This file is too large to share.');
  pending = true;
  try {
    const encoded = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = () => reject(new Error('The file could not be prepared.'));
      reader.readAsDataURL(blob);
    });
    await new Promise((resolve, reject) => {
      const timer = setTimeout(() => { window.MaldhowrNative.onmessage = null; reject(new Error('The file action timed out. Please try again.')); }, 120000);
      window.MaldhowrNative.onmessage = event => {
        try {
          const result = JSON.parse(event.data);
          if (result.kind === 'print') return;
          clearTimeout(timer); window.MaldhowrNative.onmessage = null;
          if (result.ok) resolve();
          else if (result.cancelled) reject(new DOMException('Cancelled', 'AbortError'));
          else reject(new Error(result.message || 'The file could not be saved.'));
        } catch (failure) { clearTimeout(timer); window.MaldhowrNative.onmessage = null; reject(failure); }
      };
      try { window.MaldhowrNative.postMessage(JSON.stringify({ kind, filename, mime: blob.type.split(';')[0], base64: encoded })); }
      catch (failure) { clearTimeout(timer); window.MaldhowrNative.onmessage = null; reject(failure); }
    });
    return true;
  } finally { pending = false; }
}